export const mockWordCloudService = {};
